import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isNullOrUndefined } from 'shared/utils/null.utils';
import { IVirtualTableColumn } from 'components/layout/VirtualTable/Table/components/VirtualTable';
import { VirtualTable } from 'components/layout/VirtualTable/Table';
import { Opportunity } from '../../../queries/opportunity-list.queries.types';
import { StyledNoResults } from '../styled/OpportunityListTable.styled';
import { viewAmmendOpportunityRoute } from '../../../../../routes/opportunities-management.routes';
import { getOpportunityListTableColumns } from '../utils/getOpportunityListTableColumns';
import { CopyListAndSort } from 'shared/utils/sorting.utils';

interface OpportunityTableProps {
   data?: Opportunity[];
}

const OpportunitiesListTable = ({ data = [] }: OpportunityTableProps) => {
   const history = useHistory();

   const displayDataRef = useRef<Opportunity[]>([]);
   const [displayData, setDisplayData] = useState<Opportunity[]>([]);
   const [displayColumns, setDisplayColumns] = useState<IVirtualTableColumn<Opportunity>[]>(prepairTableColumns());

   function prepairTableColumns(): IVirtualTableColumn<Opportunity>[] {
      let columns = getOpportunityListTableColumns(handleColumnClick, handleRowClick);
      columns.forEach((column: IVirtualTableColumn<Opportunity>) => {
         column.name = column.name;
      });
      return columns;
   }

   useEffect(() => {
      setDisplayData(
         data.sort((a: Opportunity, b: Opportunity) => {
            const sortValueA = a.incidentDate;
            const sortValueB = b.incidentDate;

            return (true ? sortValueA < sortValueB : sortValueA > sortValueB) ? 1 : -1;
         })
      );
      displayDataRef.current = data;
   }, [data]);

   useEffect(() => {
      let newColumns = prepairTableColumns();
      setDisplayColumns(newColumns);
   }, []);

   function handleColumnClick(ev: React.MouseEvent<HTMLElement>, column: IVirtualTableColumn<Opportunity>): void {
      const newColumns: IVirtualTableColumn<Opportunity>[] = [...displayColumns];

      const selectedColumn: IVirtualTableColumn<Opportunity> = newColumns.filter(currCol => column.key === currCol.key)[0];

      newColumns.forEach((column: IVirtualTableColumn<Opportunity>) => {
         if (column === selectedColumn) {
            selectedColumn.isSortedDescending = !selectedColumn.isSortedDescending;
            selectedColumn.isSorted = true;
         } else {
            column.isSorted = false;
         }
      });

      let newList: Opportunity[] = [];
      newList = CopyListAndSort(
         displayDataRef.current,
         selectedColumn.fieldName!,
         selectedColumn.isSortedDescending,
         selectedColumn.sortValueResolver
      );

      setDisplayColumns(newColumns);
      setDisplayData(newList);
   }

   function handleRowClick(item: Opportunity) {
      history.push(viewAmmendOpportunityRoute(item.observationId.toString()));
   }

   return (
      <React.Fragment>
         {(isNullOrUndefined(data) || data.length === 0) && (
            <StyledNoResults>No records found for the currently selected filters</StyledNoResults>
         )}

         {!isNullOrUndefined(data) && data.length > 0 && (
            <VirtualTable<Opportunity>
               columns={displayColumns}
               items={displayData}
               onRowClick={item => history.push(viewAmmendOpportunityRoute(item?.observationId.toString()))}
               keyFieldName='observationId'
            />
         )}
      </React.Fragment>
   );
};

export default OpportunitiesListTable;
